import styled from 'styled-components';
import { Flexer } from '@ontruck/orc';

const SectionTitleStyled = styled(Flexer.Parent)`
  color: ${({ skin }) => (skin === 'dark' ? 'black' : 'white')};
  text-transform: uppercase;
  font-weight: bold;
`;

export default SectionTitleStyled;
